var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vmp-custom-menu-desimg"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }